// common configuration
const config = {
    api: {
        baseUrl: "https://gatehouse.mmsecurity.cz/api"
    },
    afterLoginRoute: "dashboard",
    vueAppUrl: "https://gatehouse.mmsecurity.cz"
};

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    config["vueAppUrl"] = "http://localhost:9000";
    config["api"]["baseUrl"] = "http://localhost:9001";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_kuba") {
    config["vueAppUrl"] = "http://localhost:20201";
    config["api"]["baseUrl"] = "http://localhost:20200";
}

export const CONFIG = config;